import React from "react";

import MathMindContent from "../../components/math_mind_content";

export default function Mind() {
  return <MathMindContent />;
}
